import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { has } from 'lodash';

import { ReportGeneration } from 'Common/ObjectHelper';
import { OhioCashReceiptsReportFieldEnum as Fields } from 'Common/FieldEnum';
import { Filter, Main } from 'Containers/';
import OhioCashReceiptsReportForm from './components/OhioCashReceiptsReportForm';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { OHIO_CASH_RECEIPTS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import MPWWebApi from 'API/MPWApi';
import { toastError, toastInfo } from 'Common/ToastHelper';

export class OhioCashReceiptsReport extends Component {
  state = {
    loading: false,
    nonNeedyItemOptions: [],
  };

  getMainProps = () => {
    return {
      toolbox: {
        formName: OHIO_CASH_RECEIPTS_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: this.state.loading,
          disabled: this.state.loading,
        },
        shown: true,
      },
    };
  };

  handleSubmit = async values => {
    this.setState({ loading: true });

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'reports/ohiocashreceiptsreport',
        values
      );
      const report = response.data.Data;

      if (!report) {
        toastInfo('No data found!');
      }

      ReportGeneration(report, 'Ohio Cash Receipts');
    } catch (error) {
      return this.handleResponseError(error);
    }

    this.setState({ loading: false });
  };

  handleResponseError = error => {
    has(error, 'response.data.Errors')
      ? error.response.data.Errors.forEach(e => {
          toastError(e.Title);
        })
      : toastError(error.response.statusText);
    return this.setState({ loading: false });
  };

  render() {
    const { loading } = this.state;
    return (
      <Fragment>
        {loading && <LoadingPage />}
        <Filter title={'Ohio Cash Receipts Report'} />
        <Main {...this.getMainProps()}>
          <OhioCashReceiptsReportForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.MealType]: '',
              [Fields.Date]: moment().format(MONTH_YEAR_DATE_FORMAT),
              [Fields.County]: '',
              [Fields.SiteIds]: [],
            }}
          />
        </Main>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ohiocashreceiptsreport/OhioCashReceiptsReport.js